import { useAuthStore } from "@/modules/auth/store";
import { usePermissions } from "@/modules/auth/composables/usePermissions";

/**
 * Permission middleware для проверки прав доступа к роутам
 *
 * Использование в роуте:
 * meta: {
 *   permissions: 'counterparties:edit' // одно право
 *   // или
 *   permissions: ['counterparties:edit', 'counterparties:view'] // массив прав (хотя бы одно)
 * }
 *
 * @param {Object} to - целевой роут
 * @param {Object} from - исходный роут
 * @param {Function} next - функция для продолжения навигации
 */
export const permissionMiddleware = async (to, from, next) => {
  const authStore = useAuthStore();
  const { hasAccess } = usePermissions();
  const permissions = to.meta.permissions;

  // Если роут не требует проверки прав - пропускаем
  if (!permissions) {
    return next();
  }

  // Если пользователь не загружен - ждем загрузки
  if (!authStore.user) {
    try {
      await authStore.getMe();
    } catch (error) {
      console.error("Ошибка при загрузке пользователя:", error);
      return next({ name: "login" });
    }
  }

  if (hasAccess(permissions)) {
    return next();
  } else {
    return next({ name: "forbidden" });
  }
};
